import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "../../../../table.css";
import { ClearSvg } from "../../../../utility/constants/assetsManager";
import {
  colorDarkBlue,
  colorDarkGreen,
  primaryColor,
} from "../../../../utility/constants/colorManager";
import {
  APPROVAL_APPROVED_ACL,
  DASHBOARD_APPROVAL_ACL,
} from "../../../../utility/constants/valueConstants";
import ClientsDocument from "../../../pages/main_pages/clients/client_details/ClientsDocument";
import ApprovalContainer from "./ApprovalContainer";

const RowContainer = ({ title, value }) => {
  return (
    <div style={styles.rowContainer}>
      <div
        style={{
          width: "50%",
        }}
      >
        <p
          style={{
            fontSize: 13,
            fontWeight: "600",
          }}
        >
          {title} :
        </p>
      </div>
      <div>
        <p
          style={{
            fontSize: 13,
            color: "#3A3A3A",
          }}
        >
          {value}
        </p>
      </div>
    </div>
  );
};

const DocumentContainers = ({ title }) => {
  return (
    <div>
      <p
        style={{
          ...styles.documentText,
          margin: 0,
          color: "#6C6B6B",
          fontWeight: "400",
        }}
      >
        {title}
      </p>
      <div
        style={{
          ...styles.documentContainer,
        }}
      >
        <p
          style={{
            ...styles.documentText,
          }}
        >
          {title}
        </p>
      </div>
    </div>
  );
};
const RateTable = ({ data }) => {
  return (
    <table className="view-more-table">
      <tr className="view-more-table-header">
        <th>Client Rate</th>
        <th>Reseller Rate</th>
        <th>Neokred Rate</th>
      </tr>
      <tbody className="view-more-table-body">
        <tr>
          {data ? (
            <td>
              {data?.comissionRate ? data?.comissionRate[0]?.value : "N/A"} %
            </td>
          ) : (
            <td>{"N/A"} %</td>
          )}
          <td>{data?.resellerRate} %</td>
          <td>{data?.neokredRate} %</td>
        </tr>
      </tbody>
    </table>
  );
};

const Data = [
  { name: "Basic Details" },
  { name: "Bank account Details" },
  { name: "Documents" },
];
const Tabs = ({ currentStep, data, onClick }) => {
  return (
    <div style={{ ...styles.headStyle }}>
      {data.map((data, i) => (
        <p
          style={{
            color: currentStep === i ? primaryColor : "#b5b5b5",
            fontWeight: currentStep === i ? "600" : "400",
            fontSize: 12,
            cursor: "pointer",
            transition: "0.2s all",
          }}
          onClick={() => onClick(i)}
        >
          {data?.name}
        </p>
      ))}
    </div>
  );
};
function ViewMoreApproval({
  onClose,
  data,
  isButtonsRequired = true,
  onSuccess,
  isActiveButtonRequired = false,
  onClickApproveReject,
  loading = false,
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const [rates, setRates] = useState({});
  const [selectedServiceProvider, setSelectedServiceProvider] = useState("");
  const [serviceType, setServiceType] = useState("");
  const aclData = useSelector((state) => state.aclSlice.aclList);

  useEffect(() => {
    setSelectedServiceProvider(data?.service[0]?.serviceProviderName);
    setRates(data?.service[0]);
    setServiceType(data?.service[0]?.serviceType);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        padding: "10px 10px",
        margin: "10px 0px",
        overflow: "auto",
        position: "relative",
        maxHeight: "80vh",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          borderRadius: 5,
          cursor: "pointer",
          position: "absolute",
          right: 0,
        }}
        onClick={onClose}
      >
        <img
          src={ClearSvg}
          style={{
            width: 30,
            height: 30,
          }}
        />
      </div>

      <ApprovalContainer
        showViewButton={false}
        isDividerRequired={false}
        data={data}
        onClose={onClose}
        isButtonsRequired={isButtonsRequired}
        onSuccess={onSuccess}
      />

      <div
        style={{
          backgroundColor: "rgb(249, 249, 251)",
          padding: "8px 10px",
          marginBottom: 10,
          display: "flex",
          gap: 20,
          border: "1px solid rgb(243, 243, 243)",
        }}
      >
        {data?.service?.map((rate, i) => {
          return (
            <p
              key={i}
              style={{
                color:
                  selectedServiceProvider === rate?.serviceProviderName
                    ? "rgb(56, 54, 156)"
                    : "rgb(181, 181, 181)",
                fontWeight:
                  selectedServiceProvider === rate?.serviceProviderName
                    ? "600"
                    : "400",
                fontSize: "12px",
                cursor: "pointer",
                textTransform: "capitalize",
              }}
              onClick={() => {
                setSelectedServiceProvider(rate?.serviceProviderName);
                setRates(rate);
              }}
            >
              {rate?.serviceProviderName}
            </p>
          );
        })}
      </div>
      <RateTable data={rates} />
      <Tabs
        data={Data}
        currentStep={currentStep}
        onClick={(data) => setCurrentStep(data)}
      />

      {currentStep === 0 ? (
        <div>
          <RowContainer
            title="Name"
            value={data?.firstName + " " + data?.lastName}
          />
          <RowContainer title="Email Id" value={data?.email} />
          <RowContainer
            title="Mobile Number"
            value={"+91 " + data?.mobileNumber}
          />
        </div>
      ) : currentStep === 1 ? (
        <div>
          {data?.service[0]?.serviceType === "payin" && (
            <>
              <RowContainer
                title="Name as per bank"
                value={data?.nameAsPerBank}
              />
              <RowContainer
                title="Bank account Number"
                value={data?.bankAccountNumber}
              />
              <RowContainer title="Bank IFSC code" value={data?.bankIfscCode} />
            </>
          )}
          {data?.service[0]?.serviceType === "payout" && (
            <>
              <RowContainer
                title="Name as per bank"
                value={data?.remitterNameAsPerBank}
              />
              <RowContainer
                title="Bank account Number"
                value={data?.remitterAccountNumber}
              />
              <RowContainer
                title="Bank IFSC code"
                value={data?.remitterIfscCode}
              />
            </>
          )}
        </div>
      ) : currentStep === 2 ? (
        <div
          style={{
            margin: "10px 0px",
          }}
        >
          {/* <DocumentContainers title="PAN Card" />
          <DocumentContainers title="GST Certificate" />
          <DocumentContainers title="Incorporate Certificate" /> */}
          <ClientsDocument data={data} />
        </div>
      ) : null}

      {isActiveButtonRequired && aclData.includes(DASHBOARD_APPROVAL_ACL) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#F9F9FB",
            border: "1px solid #F3F3F3",
            width: "100%",
            padding: "15px 10px",
          }}
        >
          <p
            style={{
              fontSize: 14,
              color: colorDarkBlue,
              fontWeight: "600",
            }}
          >
            Rejected By Mistake
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(63, 169, 47, 0.1)",
              marginLeft: 16,
              borderRadius: "5px",
              cursor: "pointer",
              padding: "8px 15px",
              pointerEvents: loading ? "none" : "all",
            }}
            onClick={() => {
              onClickApproveReject(data?.userId);
            }}
          >
            <p
              style={{
                color: colorDarkGreen,
                // fontSize: loading1 ? 10 : 12,
              }}
            >
              {loading ? "loading..." : "Approve"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
const styles = {
  headStyle: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#F9F9FB",
    border: "1px solid #F3F3F3",
    padding: 10,
    marginTop: 20,
  },
  rowContainer: {
    width: "100%",
    display: "flex",
    margin: "25px 0px",
    transition: "1s all",
  },
  documentContainer: {
    width: "100%",
    backgroundColor: "rgba(111, 108, 255, 0.05)",
    height: 45,
    border: "1px solid #B4B3FF",
    margin: "10px 0px",
    borderRadius: 4,
    alignItems: "center",
    display: "flex",
    cursor: "pointer",

    maxWidth: 350,
    minWidth: 280,
  },
  documentText: {
    color: primaryColor,
    fontWeight: "600",
    fontSize: 12,
    marginLeft: 20,
  },
};
export default ViewMoreApproval;
